<div class="registration" *ngIf="registrationLink">
  <div class="registration-card">
    <div class="logo-image">
      <img [src]="organisationUnitLogoUrl || 'assets/img/logo.jpg'" alt="Logo" />
    </div>
    <h1 class="title">{{ 'REGISTRATION.TITLE' | translate }}</h1>
    <h2 class="subtitle">{{ registrationLink.title }}</h2>
    <app-panel>
        <p class="description">
            {{ registrationLink.description }}
        </p>
        <h2 class="personal-data">{{ 'REGISTRATION.YOUR-PERSONAL-DATA' | translate }}:</h2>
        <div class="form-container">
            <dx-form
                #form
                labelMode="floating"
                [showColonAfterLabel]="false"
                [formData]="formData"
            >
                <ng-container *ngFor="let field of registrationFieldConfigs">
                    <dxi-item
                        *ngIf="field.visible"
                        [dataField]="field.key"
                    >
                        <dxo-label 
                            [text]="getLabelKey(field.key) | translate"
                        ></dxo-label>
                        <dxi-validation-rule
                            *ngIf="field.required"
                            type="required"
                            [message]="getRequiredMessageKey(field.key) | translate">
                        </dxi-validation-rule>
                        <dxi-validation-rule
                            *ngIf="field.key === emailKey"
                            type="email"
                            [message]="'VALIDATIONS.EMAIL-INVALID' | translate"
                        ></dxi-validation-rule>
                    </dxi-item>
                </ng-container>

                <dxi-item dataField="accepted">
                    <dxo-label [visible]="false"></dxo-label>
                    <dxi-validation-rule
                        type="required"
                        [message]="'VALIDATIONS.ACCEPTED-REQUIRED' | translate"
                    ></dxi-validation-rule>
                    <dxi-validation-rule
                        type="compare"
                        [comparisonTarget]="mustBeTrue"
                        [message]="'VALIDATIONS.ACCEPTED-REQUIRED' | translate"
                    ></dxi-validation-rule>
                    <div *dxTemplate>
                        <div class="custom-checkbox-layout">
                            <div class="row">
                                <div class="col-auto">
                                     <dx-check-box
                                        [value]="formData.accepted"
                                        (onValueChanged)="formData.accepted = $event.value"
                                    ></dx-check-box>
                                </div>
                                <div class="col">
                                    <span class="checkbox-text" [innerHTML]="privacyPolicyTextHtml"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                 </dxi-item>

            </dx-form>
            <div class="actions-container">
                <dx-button
                    [disabled]="!formData.accepted"
                    class="submit-button"
                    [text]="'REGISTRATION.REGISTER-AND-CONTINUE' | translate"
                    color="primary"
                    (onClick)="register()"
                ></dx-button>
            </div>
        </div>
    </app-panel>
    <div class="footer">
        <div class="location" [innerHTML]="organisationUnitFooterHtml"></div>
        <div class="service" [innerHTML]="serviceProvidedTextHtml"></div>
    </div>
  </div>
</div>

<app-registration-modal [(showModal)]="isRegistered" [registrationResultModel]="registrationResultModel!"/>
